import GlpLogo from './GlpLogo.vue'

export { GlpLogo }
